import React from 'react';

const Lifes = (props) => {
  
  return (
    <div className="lifes">Жизни: {props.lifes}</div>
  )
}

export default Lifes;